import { Item } from "@/lib/api/products";

export interface RecommendationScore {
  item: Item;
  score: number;
  reasons: string[];
}

/**
 * 룰베이스 기반 추천 알고리즘
 * - 같은 카테고리 우선 필터
 * - 동일 브랜드 우선
 * - 가격대 ±30% 범위 내 가산점
 * - 최근 등록 순 정렬
 */
export function ruleBasedRecommendation(
  currentItem: Item,
  candidateItems: Item[]
): RecommendationScore[] {
  const currentBrand = (currentItem as any).brand || "";
  const currentCategory = (currentItem as any).category || "";
  const currentPrice = currentItem.price;
  const priceRange = currentPrice * 0.3; // ±30%

  return candidateItems.map((item) => {
    let score = 0;
    const reasons: string[] = [];

    // 1. 카테고리 일치 (기본 점수 30점)
    const itemCategory = (item as any).category || "";
    if (currentCategory && itemCategory === currentCategory) {
      score += 30;
      reasons.push("같은 카테고리");
    }

    // 2. 브랜드 일치 (가중치 높음, 40점)
    const itemBrand = (item as any).brand || "";
    if (currentBrand && itemBrand === currentBrand) {
      score += 40;
      reasons.push("같은 브랜드");
    }

    // 3. 가격대 근접도 (±30% 범위 내)
    const priceDiff = Math.abs(item.price - currentPrice);
    if (priceDiff <= priceRange) {
      const priceScore = Math.round(30 * (1 - priceDiff / priceRange));
      score += priceScore;
      reasons.push(`가격대 유사 (${Math.round((priceDiff / currentPrice) * 100)}% 차이)`);
    }

    // 4. 최근 등록일 가산점 (최대 10점)
    let daysSinceCreated = 999;
    if (item.createdAt) {
      const createdAt = item.createdAt.seconds
        ? new Date(item.createdAt.seconds * 1000)
        : new Date(item.createdAt);
      const now = new Date();
      daysSinceCreated = Math.floor(
        (now.getTime() - createdAt.getTime()) / (1000 * 60 * 60 * 24)
      );
    }
    if (daysSinceCreated <= 7) {
      score += 10;
      reasons.push("최근 등록");
    } else if (daysSinceCreated <= 30) {
      score += 5;
      reasons.push("최근 등록 (1개월 이내)");
    }

    return {
      item,
      score,
      reasons,
    };
  });
}

